import { EuiButton, EuiCallOut, EuiCheckbox, EuiFlexGroup, EuiFlexItem } from '@elastic/eui';
import React, { useEffect, useMemo, useState } from 'react';

const _msgInfo = (<p>Esta función realizará un abono negativo de los <strong>partes seleccionados que se encuentren facturados</strong>.</p>);

export const AbonoNormalScreen = (props)=>{

    const {handleAbonar,estadoPartes} = props;

    const {nPartes,nPartesFacturados,nPartesNoFacturados,nPartesConAbono} = estadoPartes;
    const [checkedConfirm, setCheckedConfirm] = useState(false);

    useEffect(()=>{{setCheckedConfirm(false)}},[props])

    const onRealizarAbono = ()=>{
        handleAbonar()
    }

    const PartesNoFacturados = useMemo(()=>{
        return nPartesNoFacturados>0 ?
        (<EuiFlexItem>
            <EuiCallOut iconType={'cross'} size='s' color='danger' title={<p>Error. <strong>({nPartesNoFacturados})</strong> partes sin facturar.</p>}/>
        </EuiFlexItem>)
        : null
    },[nPartesNoFacturados])

    const PartesConAbono = useMemo(()=>{
        return nPartesConAbono>0 ?
        (<EuiFlexItem>
            <EuiCallOut iconType={'cross'} size='s' color='danger' title={<p>Error. <strong>({nPartesConAbono})</strong> partes con abono.</p>}/>
        </EuiFlexItem>)
        : null
    },[nPartesConAbono])

    const isDisabledConfirmCheck = useMemo(()=> (nPartesNoFacturados>0 || nPartes===0 || nPartesConAbono>0)
    ,[nPartesNoFacturados, nPartes, nPartesConAbono])

    return (
        <EuiFlexGroup direction='column'>
            <EuiFlexItem>
                    <EuiCallOut size='s' color='warning' title={_msgInfo}/>
            </EuiFlexItem>
            <EuiFlexItem>
                <EuiFlexGroup direction='column'>
                    <EuiFlexItem>
                        <EuiCallOut iconType={'documentEdit'} size='s' color='success' title={<p><strong>({nPartesFacturados})</strong> partes facturados seleccionados</p>}/>
                    </EuiFlexItem>
                    {PartesNoFacturados}
                    {PartesConAbono}
                </EuiFlexGroup>
            </EuiFlexItem>
            <EuiFlexItem>
                <EuiCheckbox
                    id={'chk-confirm-abono'}
                    label="Confirmar el proceso de abono"
                    checked={checkedConfirm}
                    disabled={isDisabledConfirmCheck}
                    onChange={(e) => {setCheckedConfirm(e.target.checked)}}
                />
            </EuiFlexItem>
            <EuiFlexItem grow={false}>
                <EuiButton className='btn-abono-screen' size='s' fill isDisabled={!checkedConfirm} onClick={()=>{onRealizarAbono()}}>{`Realizar Abonos`}</EuiButton>
            </EuiFlexItem>
        </EuiFlexGroup>
    );
}